import { useRouterState } from "@tanstack/react-router";

/**
 * Returns true while the active route is inside /ask-puntt (the chat list,
 * a chat by id, or the projects index). The sidebar uses this gate in
 * three places (AskPunttProjects, AskPunttRecents, AskPunttSidebarScrollSlot)
 * and they have to agree on the answer — extracting the check into a
 * hook keeps that contract honest.
 *
 * The match is intentionally `pathname.includes("/ask-puntt")` to cover
 * both `/ask-puntt` and nested children like `/ask-puntt/$chatId` without
 * having to enumerate every child route id. The matcher is a substring
 * check rather than a route-id check because the auth-layout route tree
 * mounts multiple children under /ask-puntt and we want this hook to be
 * indifferent to which one is active.
 */
export function useIsOnAskPuntt(): boolean {
  const { matches } = useRouterState();
  return matches.some((m) => m.pathname.includes("/ask-puntt"));
}
